module.exports = __webpack_public_path__ + "static/media/HTML5.9729eb5a.png";